var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinimap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01696 11.325L4.19411 7.367C3.73206 6.82534 3.43451 6.16449 3.33611 5.46142C3.23771 4.75835 3.34251 4.04199 3.63831 3.39577C3.9341 2.74955 4.40872 2.20006 5.00688 1.81131C5.60504 1.42256 6.30213 1.21054 7.01696 1.19995C8.00785 1.20967 8.95447 1.60891 9.6495 2.31021C10.3445 3.01151 10.7313 3.95772 10.7251 4.9416C10.7255 5.79989 10.4312 6.63268 9.89079 7.30257L7.01696 11.325ZM7.01696 2.12041C6.27155 2.1289 5.56 2.43077 5.03856 2.95972C4.51712 3.48868 4.22841 4.20147 4.23583 4.9416C4.23893 5.61713 4.48371 6.26959 4.92648 6.78251L7.01696 9.72336L9.16306 6.72268C9.571 6.21709 9.79479 5.58941 9.79808 4.9416C9.8055 4.20147 9.51679 3.48868 8.99535 2.95972C8.47391 2.43077 7.76237 2.1289 7.01696 2.12041Z",
    fill: "#178477",
    stroke: "#178477",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0128 5.92499C7.57199 5.92499 8.0253 5.47168 8.0253 4.91249C8.0253 4.3533 7.57199 3.89999 7.0128 3.89999C6.45361 3.89999 6.0003 4.3533 6.0003 4.91249C6.0003 5.47168 6.45361 5.92499 7.0128 5.92499Z",
    fill: "#178477",
    stroke: "#178477",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.509 6.59996H11.593V7.49996H12.509V13.8H1.51617V7.49996H2.43224V6.59996H1.51617C1.27321 6.59996 1.04021 6.69478 0.868409 6.86357C0.696612 7.03235 0.600098 7.26127 0.600098 7.49996V13.8C0.600098 14.0387 0.696612 14.2676 0.868409 14.4364C1.04021 14.6051 1.27321 14.7 1.51617 14.7H12.509C12.752 14.7 12.985 14.6051 13.1568 14.4364C13.3286 14.2676 13.4251 14.0387 13.4251 13.8V7.49996C13.4251 7.26127 13.3286 7.03235 13.1568 6.86357C12.985 6.69478 12.752 6.59996 12.509 6.59996Z",
    fill: "#178477",
    stroke: "#178477",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimap);
export default __webpack_public_path__ + "static/media/minimap.89b7a2c8f05dc417b78fc89174f7ef63.svg";
export { ForwardRef as ReactComponent };